module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.icons[_vm.name])
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d5b040"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/audiorecording/icon-button.vue
// module id = 333
// module chunks = 42